<ng-container *ngFor="let blockId of blockIdList; let index = index">
  <app-block-factory
    [blockId]="blockId"
    [injectData]="injectData"
    (isVisibleChanged)="isVisibleChanged.emit({ isVisible: $event, index })"
    *ngIf="blockVisibility[index] === undefined || blockVisibility[index] === true"
  >
  </app-block-factory>
</ng-container>
